module.exports = __webpack_public_path__ + "static/img/4.875e24f8.jpg";